/**
 * Provider for `events`
 * @module
 */

var eventsHelper = require('../../helpers/events');

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'events',

  // visitor events have their own persistence mechanism via visitor_events store
  isTransient: true,

  getter: [
    function() {
      return eventsHelper.getEvents();
    },
  ],
};
